<div class="notification-container">
  @for (notification of notifications; track notification.id) {
    <div class="notification" [ngClass]="'notification-' + notification.type">
      <div class="notification-content">
        <span class="notification-message">{{ notification.message }}</span>
      </div>
      <button class="notification-close" (click)="dismiss(notification.id)" aria-label="Close">
        ×
      </button>
    </div>
  }
</div>
